import BatchList from "./screens/BatchList"

const ManageBatches = () => {
    return (
        <BatchList />
    )
}

export default ManageBatches